import { buildPaginatedListStore } from "./utils/storeBuilders";

export const useCustomerListStore = buildPaginatedListStore("customerList", "/customers/", "Aucun client trouvé");
